import { createSlice } from '@reduxjs/toolkit'

const contactInfoSlice = createSlice({
    name: 'contact-info',
    initialState: { error: null, loading: false, success: false },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setSuccess(state, action) {
            const { payload } = action

            state.success = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        contactInfo() {},
        gdprAgreements() {},
        uploadImage() {},
    },
})

const { actions, reducer } = contactInfoSlice

export const { setLoading, setSuccess, setError, contactInfo, gdprAgreements, uploadImage } = actions

export default reducer
